var map = {
	"./avatar_r_1.png": "5d8b",
	"./avatar_r_10.png": "8dfe",
	"./avatar_r_11.png": "2f82",
	"./avatar_r_12.png": "cda8",
	"./avatar_r_13.png": "192a",
	"./avatar_r_14.png": "0120",
	"./avatar_r_15.png": "3b3b",
	"./avatar_r_16.png": "a4dd",
	"./avatar_r_17.png": "3611",
	"./avatar_r_18.png": "ec9a",
	"./avatar_r_19.png": "5554",
	"./avatar_r_2.png": "b899",
	"./avatar_r_20.png": "dc08",
	"./avatar_r_3.png": "e4f5",
	"./avatar_r_4.png": "8e62",
	"./avatar_r_5.png": "ce9f",
	"./avatar_r_6.png": "1c97",
	"./avatar_r_7.png": "3a9c",
	"./avatar_r_8.png": "e829",
	"./avatar_r_9.png": "1883"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a140";